import React from 'react';
import { Check, ArrowUpRight } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const DownloadCTA = () => {
  const { isDark } = useTheme();

  return (
    <section className="py-8 md:py-12 w-full">
      <div className="w-full mx-auto px-2 md:px-16">
        <div
          className="rounded-[25px] p-[2px]"
          style={{ background: isDark ? 'linear-gradient(to bottom, #104B30, #0B3E3D)' : 'linear-gradient(135deg, #177755, #0d9e6a)' }}
        >
          <div
            className="rounded-[25px] px-6 md:px-20 py-10 md:pt-12 md:pb-16"
            style={{
              background: isDark
                ? 'radial-gradient(circle at center -30%, #022017 0%, #000000 100%)'
                : 'radial-gradient(circle at center -30%, #0d5c3a 0%, #0a3d28 100%)',
              borderRadius: '25px',
            }}
          >
            <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-0">
              <div className="w-full lg:w-[55%]">
                <h2 className="text-[36px] md:text-[43px] font-bold text-center lg:text-left leading-tight"
                  style={{
                    backgroundImage: 'linear-gradient(to right, #28F5AB 0%, #28F5AB 70%, #00FFFF 100%)',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}>
                  Try Vuzo for Free
                </h2>
                <p className="text-[14px] md:text-[16px] text-white/80 text-center lg:text-left mt-3 mb-8">
                  Limitless Learning Starts Here — Where Ideas Spark Creativity
                </p>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-8">
                  {['AI Assistants', 'PDF Analyzer', 'Object Identifier'].map(feat => (
                    <div key={feat} className="flex items-center gap-2">
                      <div className="rounded-full flex items-center justify-center shrink-0"
                        style={{ background: 'linear-gradient(to bottom, #248063, #40DCAA)', width: '22px', height: '22px', padding: '4px' }}>
                        <Check className="w-3 h-3 text-white" />
                      </div>
                      <span className="text-white text-[13px] md:text-[14px]">{feat}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex items-center justify-center lg:justify-end w-full lg:w-[45%]">
                <a
                  href="https://chat.vuzo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-2 px-8 py-4 rounded-2xl text-[17px] font-semibold bg-white text-[#0d5c3a] hover:bg-[#f0fff8] shadow-xl transition-all duration-200"
                >
                  Open chat.vuzo.com
                  <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadCTA;
